<template>
  <el-dialog
    :close-on-click-modal="false"
    title="修改"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="140px"
      >
        <!-- 员工姓名 -->
        <span slot="userName" slot-scope="prop">{{prop.form.userName}}</span>
        <!-- 员工姓名 end -->
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  workerEdit,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '员工姓名',
            value: 'userName',
            slot: true,
          },
          {
            label: '应出勤天数',
            value: 'attendanceDaysNumber',
            type: 'input',
          },
          {
            label: '实际出勤天数',
            value: 'actualAttendanceDays',
            type: 'input',
          },
          {
            label: '基本工资',
            value: 'basicSalaryFee',
            type: 'input',
          },
          {
            label: '绩效工资',
            value: 'meritPay',
            type: 'input',
          },
          {
            label: '加班补贴',
            value: 'subsidyFee',
            type: 'input',
          },
          {
            label: '个人社保缴纳',
            value: 'individualContribution',
            type: 'input',
          },
          {
            label: '个税',
            value: 'individualIncomeTax',
            type: 'input',
          },
          {
            label: '实发工资',
            value: 'realSalaryFee',
            type: 'input',
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
          },
        ],
        rules: { // 表单验证规则
          attendanceDaysNumber: [ // 应出勤天数
            { required: true, message: '请输入应出勤天数', trigger: 'blur' },
          ],
          actualAttendanceDays: [ // 应出勤天数
            { required: true, message: '请输入实际出勤天数', trigger: 'blur' },
          ],
          basicSalaryFee: [ // 基本工资
            { required: true, message: '请输入基本工资', trigger: 'blur' },
          ],
          meritPay: [ // 绩效工资
            { required: true, message: '请输入绩效工资', trigger: 'blur' },
          ],
          subsidyFee: [ // 加班补贴
            { required: true, message: '请输入加班补贴', trigger: 'blur' },
          ],
          individualContribution: [ // 个人社保缴纳
            { required: true, message: '请输入个人社保缴纳', trigger: 'blur' },
          ],
          individualIncomeTax: [ // 个税
            { required: true, message: '请输入个税', trigger: 'blur' },
          ],
          realSalaryFee: [ // 实发工资
            { required: true, message: '请输入实发工资', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        this.originData = item;
        item.basicSalaryFee = item.basicSalaryFeeDouble;
        item.meritPay = item.meritPayDouble;
        item.subsidyFee = item.subsidyFeeDouble;
        item.individualContribution = item.individualContributionDouble;
        item.individualIncomeTax = item.individualIncomeTaxDouble;
        item.realSalaryFee = item.realSalaryFeeDouble;
        this.$refs.customForm.setVal(item);
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await workerEdit({
        ...this.originData,
        ...form,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
